export const messageTemplateItem = {
    id: 0,
    name: '',
    messageTypeId: 0,
    englishContent: '',
    spanishContent: '',
    baseId: 0,
    templateContentCode:'',
}   
